























import {Component, Prop, Vue} from 'vue-property-decorator'
import {Endereco} from '@/model/resource/Endereco'
import {InputEnderecoSchema} from '@/schema/resource/Endereco/InputEnderecoSchema'

@Component
export default class FormEndereco extends Vue {
  @Prop({type: Endereco, required: true}) model!: Endereco
  @Prop({type: Array, default: null}) schemaFields!: string[]

  enderecoSchema = new InputEnderecoSchema()

  get computedModel() {
    return this.model
  }

  set computedModel(val: Endereco | null) {
    this.$emit('input', val)
  }

  created() {
    if (!this.computedModel) {
      this.computedModel = new Endereco()
    }
  }
}
